/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import LabTestOrdersidactivateLabTestOrder from './LabTestOrdersidactivateLabTestOrder';

/**
 * The IdActivateBody model module.
 * @module model/IdActivateBody
 * @version v0.3
 */
export default class IdActivateBody {
  /**
   * Constructs a new <code>IdActivateBody</code>.
   * @alias module:model/IdActivateBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IdActivateBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IdActivateBody} obj Optional instance to populate.
   * @return {module:model/IdActivateBody} The populated <code>IdActivateBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IdActivateBody();
      if (data.hasOwnProperty('lab_test_order'))
        obj.labTestOrder = LabTestOrdersidactivateLabTestOrder.constructFromObject(data['lab_test_order']);
    }
    return obj;
  }
}

/**
 * @member {module:model/LabTestOrdersidactivateLabTestOrder} labTestOrder
 */
IdActivateBody.prototype.labTestOrder = undefined;

